import React from 'react';
import { Card } from 'react-bootstrap';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';

const PHChart = ({ data }) => {
  // Formatea los datos para la gráfica
  const chartData = data.map(item => ({
    hora: new Date(item.fecha + 'T' + item.hora).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    ph: item.ph_cruda
  }));

  return (
    <Card className="mb-4">
      <Card.Header as="h6">pH del Agua Cruda Durante el Día</Card.Header>
      <Card.Body>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="hora" />
            <YAxis domain={[0, 14]} label={{ value: 'pH', angle: -90, position: 'insideLeft' }} />
            <Tooltip />
            <Legend />
            <ReferenceLine y={7} stroke="green" strokeDasharray="3 3" label="Neutro" />
            <Line 
              type="monotone" 
              dataKey="ph" 
              stroke="#82ca9d" 
              name="pH" 
              dot={{ r: 3 }} 
              activeDot={{ r: 8 }} 
            />
          </LineChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default PHChart;